/** dropされた分を詰めてindexが連番になるように調整する */
export const moveForwardIndex = (
  index: number,
  droppedIndex: number[],
): number => {
  const droppedIndexCount = droppedIndex.filter(i => i < index).length
  return index - droppedIndexCount
}
